import * as React from 'react';

import { Button } from '@coursera/cds-core';

import type { UseCurriculum_PersonalizedSegmentCourseFragment as SegmentCourse } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/dpmSharedFragments';

import _t from 'i18n!nls/degree-home';

type Props = {
  course: SegmentCourse;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

const EnrollmentButton = ({ course, onClick }: Props) => {
  const hasLinkedCourseraCourse = !!course.segmentCourse.course.courseraCourse;
  return (
    <Button variant="ghost" size="small" onClick={onClick}>
      {hasLinkedCourseraCourse ? _t('Enrollment options') : _t('Coming soon')}
    </Button>
  );
};

export default EnrollmentButton;
